import React from "react"

import Grid from "../shared/grid"
import Checkmark from "../shared/svg/check-mark"

import { useStaticQuery, graphql } from "gatsby"
import TypeCardGrid from "../../design-system/templates/type-card-grid-content-promo"
import VariantContainer from "../../design-system/atoms/variant-container"

import {
  TiersContainer,
  TierCardContainer,
  Title,
  Description,
} from "./partner-types-tiers.style"
import Button from "../../design-system/atoms/button"

import { TierCard } from "../../design-system/atoms/accent-cards"

export default function PartnerTypes(props) {
  const query = useStaticQuery(graphql`
    query {
      referralLogo: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/01_desktop/referral_partners_icon.svg"
        }
      ) {
        publicURL
      }
      implementationLogo: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/01_desktop/implementation_icon.svg"
        }
      ) {
        publicURL
      }
    }
  `)

  const cardContents = [
    {
      logo: query.referralLogo.publicURL,
      title: "Referral Partners",
      description:
        "Refer your clients to Mappedin’s growing suite of mapping products and work together on the digital transformation.",
    },
    {
      logo: query.implementationLogo.publicURL,
      title: "Implementation Partners",
      description:
        "Customize, integrate and implement the Mappedin platform through our SDKs and map exports.",
    },
  ]

  return (
    <>
      <VariantContainer
        variants={[
          { padding: "64px 0", borderBottom: "1px solid #2e2e2e26" },
          null,
          { padding: "128px 0" },
        ]}
      >
        <TypeCardGrid
          title="Customer Success"
          description="We recognize that not all partners are alike. Our value-based and
            flexible partner framework provides opportunities to refer, re-sell,
            develop, and integrate."
          cardContents={cardContents}
          showScrollButton={false}
        />
      </VariantContainer>
      <TiersContainer>
        <Grid>
          <Title>Partner Tiers</Title>
          <Description>
            Whether you’re looking to earn referral revenue, find new
            opportunities with existing clients, acquire new customers, build
            applications, or deliver value-add services, Mappedin will support
            your efforts every step of the way.
          </Description>
          <TierCardContainer>
            <TierCard accentColor="#3E8551">
              <TierCard.Title>Tier 1</TierCard.Title>
              <TierCard.Description>
                Explore a business strategy with Mappedin or capitalize on
                mapping opportunities.
              </TierCard.Description>
              <TierCard.Subtitle>Benefits</TierCard.Subtitle>
              <TierCard.List>
                <TierCard.ListItem>Sales Support</TierCard.ListItem>
                <TierCard.ListItem>Quarterly Check-ins</TierCard.ListItem>
                <TierCard.ListItem>Base % of Closed Deals</TierCard.ListItem>
                <TierCard.ListItem>
                  Internal Use of Mappedin Products
                </TierCard.ListItem>
              </TierCard.List>
            </TierCard>
            <TierCard accentColor="#2B5776">
              <TierCard.Title>Tier 2</TierCard.Title>
              <TierCard.Description>
                Develop your map and navigation product suites and grow through
                installed-base client engagements.
              </TierCard.Description>
              <TierCard.Subtitle>Benefits</TierCard.Subtitle>
              <TierCard.List>
                <TierCard.AccentListItem color="#2B5776">
                  <Checkmark color="#2B5776" />
                  Tier 1 Benefits +
                </TierCard.AccentListItem>
                <TierCard.ListItem>Higher % of Closed Deals</TierCard.ListItem>
                <TierCard.ListItem>Sales Certification</TierCard.ListItem>
                <TierCard.ListItem>Lead Sharing</TierCard.ListItem>
                <TierCard.ListItem>Monthly Meetings</TierCard.ListItem>
                <TierCard.ListItem>Logo in Partner Register</TierCard.ListItem>
              </TierCard.List>
            </TierCard>
            <TierCard accentColor="#B67935">
              <TierCard.Title>Tier 3</TierCard.Title>
              <TierCard.Description>
                Build advanced product integrations, industry knowledge, and
                co-sell opportunities.
              </TierCard.Description>
              <TierCard.Subtitle>Benefits</TierCard.Subtitle>
              <TierCard.List>
                <TierCard.AccentListItem color="#B67935">
                  <Checkmark color="#B67935" />
                  Tier 1 & 2 Benefits +
                </TierCard.AccentListItem>
                <TierCard.ListItem>Highest % of Closed Deals</TierCard.ListItem>
                <TierCard.ListItem>Shared Slack Channel</TierCard.ListItem>
                <TierCard.ListItem>Joint Product Offerings</TierCard.ListItem>
                <TierCard.ListItem>Developer Support</TierCard.ListItem>
                <TierCard.ListItem>Go-to-market resources</TierCard.ListItem>
                <TierCard.ListItem>Dedicated Partner Manager</TierCard.ListItem>
                <TierCard.ListItem>Demo Venue</TierCard.ListItem>
              </TierCard.List>
            </TierCard>
          </TierCardContainer>
          <Button.ScrollLink
            to="contact-form"
            smooth
            duration={1000}
            variants={[
              {
                gridColumn: "1 / -1",
                margin: "32px auto 0",
              },

              null,
              { margin: "48px auto 0" },
            ]}
          >
            Book a Demo
          </Button.ScrollLink>
        </Grid>
      </TiersContainer>
    </>
  )
}
